import {ApplicationConfig, importProvidersFrom, LOCALE_ID} from '@angular/core';
import {provideRouter} from '@angular/router';
import {routes} from './app.routes';
import {provideHttpClient} from "@angular/common/http";
import {ToastrModule} from "ngx-toastr";
import {provideAnimations} from "@angular/platform-browser/animations";
import {ModalModule} from "ngx-bootstrap/modal";
import {DecimalPipe, registerLocaleData} from "@angular/common";
import localeDe from '@angular/common/locales/de';

registerLocaleData(localeDe);

export const appConfig: ApplicationConfig = {
    providers: [
        provideAnimations(),
        provideRouter(routes),
        provideHttpClient(),
        DecimalPipe,
        importProvidersFrom(
            ToastrModule.forRoot(),
            ModalModule.forRoot(),
        ),
        { provide: LOCALE_ID, useValue: 'de-DE' }
    ]
};
